import cn from "classnames";

import React from "react";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton } from "@mui/material";

const ExpandBtn = ({ isExpanded, onClick }: { isExpanded: boolean; onClick: () => void }) => {
  return (
    <IconButton
      aria-label="expand"
      onClick={onClick}
      style={{ transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0" }}
      // className={cn({
      //   "rotate-180": isExpanded,
      // })}
    >
      <InfoOutlinedIcon />
    </IconButton>
  );
};

export default React.memo(ExpandBtn);
